import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ThemeService } from './services/theme.service';
import { Brand } from './models/brand.enum';
import {
  ThemeProviderEssentLightComponent,
  ThemeProviderEnergiedirectLightComponent,
  ThemeProviderSmeLightComponent,
} from './themes';

@Component({
  imports: [
    RouterModule,
    ThemeProviderEssentLightComponent,
    ThemeProviderEnergiedirectLightComponent,
    ThemeProviderSmeLightComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  readonly Brand = Brand;
  readonly themeService = inject(ThemeService);
}
